import React from "react";

const FoodSvg = ({ fill = "white", width = 43.481, height = 29.176 }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 40.392 40.423"
      style={{
        width,
        height,
        fill,
      }}
    >
      <g
        id="_014---Soda-and-Burger"
        data-name="014---Soda-and-Burger"
        transform="translate(0)"
        fill={fill}
      >
        <circle
          id="Oval"
          cx="0.647"
          cy="0.647"
          r="0.647"
          transform="translate(5.962 20.851)"
        />
        <circle
          id="Oval-2"
          data-name="Oval"
          cx="0.647"
          cy="0.647"
          r="0.647"
          transform="translate(8.873 18.91)"
        />
        <ellipse
          id="Oval-3"
          data-name="Oval"
          cx="0.809"
          cy="0.647"
          rx="0.809"
          ry="0.647"
          transform="translate(15.344 18.263)"
        />
        <ellipse
          id="Oval-4"
          data-name="Oval"
          cx="0.647"
          cy="0.809"
          rx="0.647"
          ry="0.809"
          transform="translate(4.021 24.086)"
        />
        <circle
          id="Oval-5"
          data-name="Oval"
          cx="0.809"
          cy="0.809"
          r="0.809"
          transform="translate(7.256 23.439)"
        />
        <circle
          id="Oval-6"
          data-name="Oval"
          cx="0.647"
          cy="0.647"
          r="0.647"
          transform="translate(10.167 21.498)"
        />
        <path
          id="Shape"
          d="M38.373,7.405H28.948V4.712a.673.673,0,0,1,.673-.673h5.386a2.02,2.02,0,0,0,0-4.039H28.948a4.043,4.043,0,0,0-4.039,4.039V7.405H15.484a2.02,2.02,0,0,0-2.02,2.02V10.1a2.015,2.015,0,0,0,1.385,1.907l.251,3.517c-.319-.019-.638-.038-.963-.038a15.949,15.949,0,0,0-2.906.273L9.6,13.636c1.564-1.548,1.651-3.373.846-4.417S7.847,7.8,5.957,8.911l-.437-.57a.673.673,0,1,0-1.066.821l.439.571c-1.569,1.548-1.646,3.377-.846,4.417.814,1.056,2.613,1.414,4.487.308L9.8,16.1C4.875,17.5,1.346,21.22,1.346,25.582a7.05,7.05,0,0,0,.051.887,2.02,2.02,0,0,0,1.3,1.675v1.478a2.687,2.687,0,0,0-.673,5.29v1.442a4.016,4.016,0,0,0,1.066,2.724H.673a.673.673,0,0,0,0,1.346H39.719a.673.673,0,0,0,0-1.346H36.19a4.024,4.024,0,0,0,1.058-2.434L39.008,12A2.014,2.014,0,0,0,40.392,10.1V9.425a2.02,2.02,0,0,0-2.02-2.02ZM5.111,13.33c-.539-.7-.044-1.808.611-2.516L6.1,11.3a.673.673,0,1,0,1.066-.821l-.373-.484c.814-.433,2.036-.667,2.589.051.669.868-.224,2.3-1.106,2.976s-2.491,1.179-3.161.31Zm21.144-9.29a2.693,2.693,0,0,1,2.693-2.693h6.059a.673.673,0,0,1,0,1.346H29.621a2.02,2.02,0,0,0-2.02,2.02V7.405H26.255ZM37.409,15.484H16.447l-.24-3.366H37.65Zm-1.251,17.5H28.179a2.652,2.652,0,0,0,.1-.673,2.693,2.693,0,0,0-2.693-2.693V28.14a2.01,2.01,0,0,0,1.294-1.664,7.084,7.084,0,0,0,.053-.894c0-.254-.025-.5-.048-.754a2.689,2.689,0,0,0-.625-5.3,2.657,2.657,0,0,0-1.481.461,12.2,12.2,0,0,0-4.283-3.154H37.313Zm-10.576-2.02a1.346,1.346,0,0,1,0,2.693H13.07l2.693-2.693Zm.673,5.386V34.911a2.677,2.677,0,0,0,1.089-.578h8.717L35.9,36.546a2.706,2.706,0,0,1-2.688,2.5h-8A4.018,4.018,0,0,0,26.255,36.353Zm-.691-15.282a1.337,1.337,0,1,1,1.085,2.419,8.709,8.709,0,0,0-1.085-2.419Zm-14.888-3.83L12.258,19.3a.673.673,0,0,0,1.066-.822l-1.159-1.5a14.89,14.89,0,0,1,1.972-.139c6.311,0,11.445,3.926,11.445,8.752a6.041,6.041,0,0,1-.043.741.673.673,0,0,1-.673.606H3.406a.677.677,0,0,1-.673-.615,5.992,5.992,0,0,1-.04-.731c0-3.9,3.36-7.215,7.983-8.34ZM4.039,28.275h20.2v1.346H15.484a.673.673,0,0,0-.476.2L10.13,34.7,5.889,29.848a.673.673,0,0,0-.5-.227H4.039ZM1.346,32.314a1.346,1.346,0,0,1,1.346-1.346H5.08L7.436,33.66H2.693a1.346,1.346,0,0,1-1.346-1.346Zm4.712,6.732a2.693,2.693,0,0,1-2.693-2.693V35.007H8.617l.5.576a1.35,1.35,0,0,0,.969.458h.044a1.35,1.35,0,0,0,.953-.395l.638-.64H24.909v1.346a2.693,2.693,0,0,1-2.693,2.693ZM39.046,10.1a.673.673,0,0,1-.673.673H15.484a.673.673,0,0,1-.673-.673V9.425a.673.673,0,0,1,.673-.673H38.373a.673.673,0,0,1,.673.673Z"
          transform="translate(0)"
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M47.693,27a2.693,2.693,0,1,0,2.693,2.693A2.693,2.693,0,0,0,47.693,27Zm0,4.039a1.346,1.346,0,1,1,1.346-1.346A1.346,1.346,0,0,1,47.693,31.039Z"
          transform="translate(-14.706 -8.823)"
        />
        <path
          id="Shape-3"
          data-name="Shape"
          d="M45.02,40a2.02,2.02,0,1,0,2.02,2.02A2.02,2.02,0,0,0,45.02,40Zm0,2.693a.673.673,0,1,1,.673-.673A.673.673,0,0,1,45.02,42.693Z"
          transform="translate(-14.052 -13.072)"
        />
      </g>
    </svg>
  );
};

export default FoodSvg;
